const production = true;

const environment = {
    production: (production ? true : false),
    apiUrl: (production ? 'https://trendbuild-api-trendbuild.b9ad.pro-us-east-1.openshiftapps.com/api' : 'http://127.0.0.1:3001/api'),
    baseUrl: (production ? 'https://trendbuild-api-trendbuild.b9ad.pro-us-east-1.openshiftapps.com' : 'http://127.0.0.1:3001'),
};

export default environment;